module.exports = __webpack_public_path__ + "console/img/mastek_small@1x.5bb5fb97.png";